import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push

const originalReplace = VueRouter.prototype.replace

VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
            console.error('[Router] Push Error:', err);
        }
        return err;
    })
}

VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
            console.error('[Router] Replace Error:', err);
        }
        return err;
    })
}

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('../views/Home.vue')
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/login.vue')
    },
    {
        path: '/createAccount',
        name: 'createAccount',
        component: () => import('../views/createAccount.vue')
    },
    {
        path: '/product',
        name: 'product',
        component: () => import('../views/product.vue')
    },
    {
        path: '/support',
        name: 'support',
        component: () => import('../views/support.vue')
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('../views/dashboard.vue'),
        meta: { requiresAuth: true }
    },
    {
        path: '/dashboard/index',
        name: 'dashboardIndex',
        component: () => import('../views/dashboard/index.vue'),
        meta: { requiresAuth: true },
        redirect: "/dashboard/index/notice",
        children: [
            {
                path: "rewards",
                name: "rewards",
                component: () => import('../views/dashboard/rewards.vue'),
            },
            {
                path: "userlist",
                name: "userList",
                component: () => import('../views/dashboard/userList.vue'),
            },
            {
                path: "usergroup",
                name: "userGroup",
                component: () => import('../views/dashboard/userGroup.vue'),
            },
            {
                path: "tickets",
                name: "tickets",
                component: () => import('../views/dashboard/tickets.vue'),
            },
            {
                path: "aclmanager",
                name: "AclManager",
                component: () => import('../views/dashboard/aclmanager.vue'),
            },
            {
                path: "invite",
                name: "invite",
                component: () => import('../views/invite.vue'),
            },
            {
                path: "websiteSettings",
                name: "WebsiteSettings",
                component: () => import('../views/dashboard/websiteSettings.vue'),
            },
            {
                path: "setting",
                name: "userSettings",
                component: () => import('../views/settings.vue'),
            }
            ,
            {
                path: "orders",
                name: "Orders",
                component: () => import('../views/dashboard/orders.vue'),
            },
            {
                path: "statistics",
                name: "statistics",
                component: () => import('../views/dashboard/statistics.vue'),
            },
            {
                path: "promocodeUser",
                name: "promocodeUser",
                component: () => import('../views/dashboard/promocode-user.vue'),
            },
            {
                path: "promocode",
                name: "promocode",
                component: () => import('../views/dashboard/promocode.vue'),
            },
            {
                path: "giftcardUser",
                name: "giftcardUser",
                component: () => import('../views/dashboard/giftcard-user.vue'),
            },
            {
                path: "giftcard",
                name: "giftcard",
                component: () => import('../views/dashboard/giftcard.vue'),
            }
            ,
            {
                path: "leveldiscount",
                name: "leveldiscount",
                component: () => import('../views/dashboard/leveldiscount.vue'),
            }
            ,
            {
                path: "proxies/:id?",
                name: "Proxies",
                component: () => import('../views/dashboard/user-orders.vue')
            },
            {
                path: "recent-orders/:id?",
                redirect: "/dashboard/index/proxies"
            },
            {
                path: "qa",
                name: "QA",
                component: () => import('../views/dashboard/QA.vue'),
            }
            ,
            {
                path: "servers",
                name: "servers",
                component: () => import('../views/dashboard/servers.vue'),
            }
            ,
            {
                path: "servergroup",
                name: "servergroup",
                component: () => import('../views/dashboard/servergroup.vue'),
            }
            ,
            {
                path: "CIDRManage",
                name: "CIDRManage",
                component: () => import('../views/dashboard/CIDRManage.vue'),
            }
            ,
            {
                path: "AclGroupManager",
                name: "AclGroupManager",
                component: () => import('../views/dashboard/AclGroupManager.vue'),
            }
            ,
            {
                path: "productManager",
                name: "productManager",
                component: () => import('../views/dashboard/productManager.vue'),
            }
            ,
            {
                path: "productType",
                name: "productType",
                component: () => import('../views/dashboard/productType.vue'),
            }
            ,
            {
                path: "productTag",
                name: "productTag",
                component: () => import('../views/dashboard/productTag.vue'),
            },
            {
                path: "notice",
                name: "notice",
                component: () => import('../views/dashboard/Notice.vue'),
            },
            {
                path: "noticeManager",
                name: "noticeManager",
                component: () => import('../views/dashboard/NoticeManager.vue'),
            },
            {
                path: "tasks",
                name: "tasks",
                component: () => import('../views/dashboard/flower.vue'),
            }

        ]
    },
    {
        path: '/policy',
        name: 'policy',
        component: () => import('../views/policy.vue')
    }
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior() {
        return { x: 0, y: 0 }
    }
})

// Handle stale cached chunks after deployments
router.onError((error) => {
    // 匹配 JS chunk 和 CSS chunk 加载失败
    const chunkFailed = /Loading chunk \\d+ failed|ChunkLoadError|Loading CSS chunk \\d+ failed/i.test(
        error && error.message ? error.message : ""
    )
    if (chunkFailed) {
        const key = "chunk-reload-once"
        if (!sessionStorage.getItem(key)) {
            sessionStorage.setItem(key, "1")
            const hash = window.location.hash || ""
            const base = window.location.origin + window.location.pathname
            const bust = `?v=${Date.now()}`
            window.location.replace(`${base}${bust}${hash}`)
        }
    }
})

import { userPointers } from "@/api/dashboard/giftUser";
import store from '@/store';

router.beforeEach(async (to, from, next) => {
    // 1. 如果尚未初始化，执行一次全局身份验证
    if (!store.state.isInitialized) {
        console.log('[Router] Initializing application state...');
        try {
            await new Promise((resolve) => {
                userPointers(
                    (res) => {
                        store.commit('setUserInfo', res.data);
                        resolve();
                    },
                    () => {
                        store.commit('clearAuth');
                        resolve();
                    }
                );
            });
        } catch (e) {
            console.error('[Router] Initialization failed:', e);
            store.commit('clearAuth');
        }
    }

    // 2. 检查路由权限
    if (to.matched.some(record => record.meta.requiresAuth)) {
        const userInfo = store.state.userInfo;
        if (userInfo && Object.keys(userInfo).length > 0) {
            next();
        } else {
            console.log('[Router] Access denied, redirecting to login.');
            next({
                path: '/login',
                query: { redirect: to.fullPath }
            });
        }
    } else {
        next();
    }
});

export default router
